import {Component, OnInit, ViewChild} from '@angular/core';
import {
  AbstractFieldInputTypeHandlerComponent
} from '../../../../../../../components/common/field/field-input/type-handler/abstract-field-input-type-handler.component';
import {UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {FormValueModel} from '../../../../../../form/form/value/api/entity/formValue.model';
import {FileUploadComponent} from '../../../../../../../components/common/file-upload/file-upload.component';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FileItem} from 'ng2-file-upload';
import {FormDefinitionFieldModel} from '../../../../../../form/definition/field/api/entity/formDefinitionField.model';

@Component({
  selector: 'app-embedded-report-model-field-input-type-handler',
  templateUrl: './embedded-report-model-field-input-type-handler.component.html',
})
export class EmbeddedReportModelFieldInputTypeHandlerComponent extends AbstractFieldInputTypeHandlerComponent<UntypedFormControl>
    implements OnInit {

  @ViewChild('fileUpload') fileUploadComponent: FileUploadComponent;

  constructor(private formBuilder: UntypedFormBuilder) {
    super();
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): UntypedFormControl {
    return this.formBuilder.control('value', formDefinitionField.required ? Validators.required : []);
  }

  initiateForm(formValue: FormValueModel): void {
    this.jsonControl.setValue(formValue?.value);
  }

  synchronizeValue(): string {
    return this.jsonControl.value;
  }

  onFileAdded(fileItem: FileItem) {
    if (fileItem) {
      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        const base64 = btoa(event.target.result.toString());
        this.jsonControl.setValue(base64);
      };
      fileReader.readAsBinaryString(fileItem._file);
      this.fileUploadComponent.reset();
    }
  }



}
